module.exports = __webpack_public_path__ + "img/icon_map_4_on_010.d407d7f8.png";